// extracted by mini-css-extract-plugin
export var label = "_i5-2";
export var slideContainer = "_i5-0";
export var slider = "_i5-1";